import { runtimeEnv } from '../../config/runtimeEnv';
import { installTrustedScriptUrlPolicy } from '../../utils/trustedScriptUrl';

export function installAnalyticsTrustedScriptPolicy(): void {
  installTrustedScriptUrlPolicy('default', validateAnalyticsScriptUrl);
}

function validateAnalyticsScriptUrl(value: string): string {
  const scriptUrl = new URL(value, window.location.origin);
  if (
    isSelfScriptUrl(scriptUrl)
    || isConfiguredAnalyticsScriptUrl(scriptUrl)
    || isPosthogScriptUrl(scriptUrl)
    || isLinkedInInsightScriptUrl(scriptUrl)
    || isTurnstileScriptUrl(scriptUrl)
  ) {
    return scriptUrl.toString();
  }

  throw new TypeError(`Untrusted analytics script URL: ${scriptUrl.toString()}`);
}

function isConfiguredAnalyticsScriptUrl(url: URL): boolean {
  const analyticsHost = runtimeEnv.VITE_POSTHOG_HOST || runtimeEnv.VITE_PUBLIC_POSTHOG_HOST;
  if (!analyticsHost) {
    return false;
  }

  const configuredUrl = new URL(analyticsHost, window.location.origin);
  return configuredUrl.protocol === 'https:' && url.origin === configuredUrl.origin;
}

function isSelfScriptUrl(url: URL): boolean {
  return url.origin === window.location.origin;
}

function isPosthogScriptUrl(url: URL): boolean {
  if (url.protocol !== 'https:') {
    return false;
  }

  return url.hostname.endsWith('.posthog.com') || url.hostname.endsWith('.i.posthog.com');
}

function isLinkedInInsightScriptUrl(url: URL): boolean {
  if (url.origin !== 'https://snap.licdn.com') {
    return false;
  }

  return [
    '/li.lms-analytics/insight.min.js',
    '/li.lms-analytics/insight.old.min.js',
  ].includes(url.pathname);
}

function isTurnstileScriptUrl(url: URL): boolean {
  return url.origin === 'https://challenges.cloudflare.com'
    && url.pathname === '/turnstile/v0/api.js';
}
